function purchaseOrderReducer() {
  return {};
}

export default purchaseOrderReducer;
